import CryptoJS from 'crypto-js';

function hexToBytes(hex) {
  const normalized = hex.replace(/\s/g, '');
  const bytes = new Uint8Array(normalized.length / 2);
  for (let i = 0; i < normalized.length; i += 2) {
    bytes[i / 2] = parseInt(normalized.substr(i, 2), 16);
  }
  return bytes;
}

function bytesToHex(bytes) {
  return Array.from(bytes)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

function getCartSecret() {
  const secret = process.env.NX_APP_CART_SECRET_KEY?.replace(/\s/g, '');
  if (!secret) {
    throw new Error('NX_APP_CART_SECRET_KEY is not configured');
  }
  return secret;
}

function canUseWebCrypto() {
  return (
    typeof globalThis !== 'undefined' &&
    globalThis.isSecureContext === true &&
    globalThis.crypto?.subtle != null
  );
}

/** Legacy CryptoJS token (HTTP dev); backend decryptCartPayload supports this. */
function encryptLegacy(text, secret) {
  return CryptoJS.AES.encrypt(text, secret).toString();
}

/** AES-256-GCM v1 token (HTTPS); matches backend utils/cartCrypto.js. */
async function encryptV1(text, secretHex) {
  const key = await globalThis.crypto.subtle.importKey(
    'raw',
    hexToBytes(secretHex),
    { name: 'AES-GCM' },
    false,
    ['encrypt'],
  );

  const iv = globalThis.crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(text);
  const encrypted = await globalThis.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    encoded,
  );

  const encBytes = new Uint8Array(encrypted);
  const tag = encBytes.slice(encBytes.length - 16);
  const ciphertext = encBytes.slice(0, encBytes.length - 16);

  return `v1.${bytesToHex(iv)}.${bytesToHex(tag)}.${bytesToHex(ciphertext)}`;
}

/**
 * Cart source token for iscartupdated / isTeams.
 * Uses Web Crypto on HTTPS; falls back to CryptoJS on HTTP (local dev).
 */
export const encrypt = async text => {
  const secret = getCartSecret();

  if (canUseWebCrypto() && secret.length === 64) {
    try {
      return await encryptV1(text, secret);
    } catch {
      // Fall through to legacy if subtle fails unexpectedly
    }
  }

  return encryptLegacy(text, secret);
};
